import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Job} from '@cp/model';
import {CREATE_STUDY_GENERATION_JOB} from '../sharedQueries';

export function useCreateStudyGenerationJob() {
  const [createStudyGenerationJobMutation, {loading, error}] = useMutation<
    {createStudyGenerationJob: Job},
    {moduleId: string; topics?: string[]}
  >(CREATE_STUDY_GENERATION_JOB);

  const createStudyGenerationJob = async (moduleId: string, topics?: string[]) => {
    const result = await createStudyGenerationJobMutation({
      variables: {moduleId, topics},
    });

    return extractGqlData(result).createStudyGenerationJob;
  };

  return {
    createStudyGenerationJob,
    loading,
    error,
  };
}
